export enum AttendancePlace {
    Academy = 0,
    Home = 1,
}
export enum AttendanceType {
    OnTime = 0,
    Late = 1,
    Additional = 2, // 추가출석 (보강)
    Absence = 3,
}
export enum AttendancePoint {
    /** 수업 진행중 */
    InAttendance = 0,
    /** 종료된 수업  */
    AfterAttendance = 1,
}
